import React from "react";

import { T } from "services/lang/LanguageService";

type ErrorBoundaryProps = {
  showInfo?: boolean;
  children: React.ReactNode;
  onError?: (msg: string) => void;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
  errorInfo?: {
    componentStack: string;
  };
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error: any, errorInfo: any) {
    return { hasError: true, error, errorInfo };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.log("Component render failed!");
    console.log(this.props.children);
    console.log("error", error);
    console.log("errorInfo", errorInfo);
    this.setState({ error, errorInfo });

    if (this.props.onError) {
      this.props.onError(T("error.something-went-wrong"));
    }
  }

  render() {
    if (this.state.hasError) {
      const icon = <i className="pi pi-times" style={{ color: "indianred", fontSize: "3rem" }} />;
      const errorMsg = T("error.something-went-wrong");

      return (
        <div>
          <h1 style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            {icon}
            {errorMsg}
            {icon}
          </h1>
          {this.props.showInfo && (
            <div>
              {this.state.error && (
                <>
                  <h3>{T("word.info")}</h3>
                  <code style={{ whiteSpace: "pre-wrap" }}>{this.state.error.toString()}</code>
                </>
              )}

              <h3>{T("label.error-boundary.stack")}</h3>
              <code style={{ whiteSpace: "pre-wrap" }}>{this.state?.errorInfo?.componentStack}</code>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
